import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { 
	FaChartLine, 
	FaUsers, 
	FaAward, 
	FaUserTie,
	FaUserFriends,
	FaTasks,
	FaGraduationCap,
	FaTrophy,
	FaWallet,
	FaReceipt,
	FaCoins,
	FaUserCircle,
	FaGamepad,
	FaShoppingCart,
	FaBullhorn,
	FaBook,
	FaUserCog,
	FaShieldAlt,
	FaDatabase,
	FaTachometerAlt,
	FaFileAlt,
	FaLock
} from 'react-icons/fa';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';

import connection01 from '../../../assets/images/public/connection-01.png';
import connection02 from '../../../assets/images/public/connection-02.png';
import connection03 from '../../../assets/images/public/connection-03.png';
import connection04 from '../../../assets/images/public/connection-04.png';
import connection05 from '../../../assets/images/public/connection-05.png';
import connection06 from '../../../assets/images/public/connection-06.png';
import connection07 from '../../../assets/images/public/connection-07.png';
import connection08 from '../../../assets/images/public/connection-08.png';
import connection09 from '../../../assets/images/public/connection-09.png';
import ssConnection01 from '../../../assets/images/public/ss-connection-01.png';
import ssConnection02 from '../../../assets/images/public/ss-connection-02.png';
import ssConnection03 from '../../../assets/images/public/ss-connection-03.png';

import "./styles.scss";

const LandingPage = () => {
	const [isMenuActive, setIsMenuActive] = React.useState(false);

	return (
		<>
			<Header />
			<main>
				<section className="title pt-sm-8 pt-5 pb-3 pb-sm-5">
					<Container>
						<Row className="justify-content-center">
							<Col lg={10} className="text-center">
								<div className="bg-slate rounded-pill text-white text-sm text-bold px-2 py-1 d-inline-block mb-3">Jarvis Connection®</div>
								<h2 className="mb-0">Jarvis Connection® Yeni Nesil Sadakat Programı</h2>
							</Col>
						</Row>
					</Container>
				</section>

				<section className="content mb-md-8 mb-5">
					<Container>
						<Row className="justify-content-center">
							<Col lg={10}>
								<p className="h4 fw-light lh-base text-body mb-0 opacity-50 text-center fs-18 text-slate mb-5">İşin Geleceği Sadakatin Yeniden Tanımlanmasıyla Başlıyor. Jarvis Connection®, sadakat deneyimini satın alma anından çok önceye, etkisinin ise sadece puanlara değil davranışa dokunduğu bütün bir yola dönüştürüyor. Her temas noktasından veri toplayan, bu veriyi davranış modellerine çeviren, kullanıcıyı segmentlere ayıran ve sadakat davranışının yeniden şekillenmesini sağlayan bütüncül bir motor sunuyoruz.</p>
								<img src={ssConnection01} alt="Jarvis Connection®" className="mb-3" />
							</Col>
						</Row>
					</Container>
				</section>

				<section className="bg-gray-lightest py-sm-10 py-5" id="bayi-sadakat">
					<Container>
						<Row className="text-center mb-sm-9 mb-5 justify-content-center">
							<Col lg={10} className="col-10">
								<h2 className="mb-4">Bayi Sadakat Programı</h2>
								<p className="h4 fw-light lh-base text-body mb-0 opacity-50 fs-18 text-slate">
									Jarvis Connection®, bayilere özel geliştirilmiş sadakat programlarıyla satış ağlarında sürdürülebilir bağlılık sağlar. Satış, eğitim, kampanya katılımı, teknik yeterlilik ve müşteri yönetimi gibi pek çok alandaki aksiyonlar puanlanabilir hale getirilir. Bu sayede bayiler, sadece ciroya değil çok boyutlu başarıya dayalı olarak ödüllendirilir. Sadakat programı kurumun hedeflerine göre şekillendirilir ve bayi motivasyonunu sürekli canlı tutar.
								</p>
							</Col>
						</Row>
						<Row className="gy-8 row-cols-lg-3 row-cols-2">
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaChartLine size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Satış Bazlı</h3>
									<p className="mb-0 fw-light small text-slate">Bayilerden nihai tüketiciye kadar tüm satış verileri sadakat deneyimine dönüştürülür. KPI bazlı hedef kurguları, satışın ötesine geçerek davranış değişimini tetikler.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaBullhorn size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Kampanya Katılımı</h3>
									<p className="mb-0 fw-light small text-slate">Bayilerin aktif katılımını teşvik eden segment bazlı kampanya tasarımları sayesinde doğru hedef kitleye ulaşım sağlanır.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaGraduationCap size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Eğitim / Sertifikasyon</h3>
									<p className="mb-0 fw-light small text-slate">Bayi çalışanlarına özel eğitimler ve sertifikasyon süreçleriyle bilgi birikimi artırılırken, bu gelişim ödül sistemine dahil edilir.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaUserTie size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Müşteri Yönetimi</h3>
									<p className="mb-0 fw-light small text-slate">Bayilerin müşteri yönetim süreçlerini analiz eden ve performanslarını ödüllendiren yapı sayesinde hizmet kalitesi sürekli iyileştirilir.</p>
								</div>
							</Col>
						</Row>
					</Container>
				</section>

				<section className="py-sm-10 py-5" id="calisan-sadakat">
					<Container>
						<Row className="text-center mb-sm-9 mb-5 justify-content-center">
							<Col lg={10} className="col-10">
								<h2 className="mb-4">Çalışan Sadakat Programı</h2>
								<p className="h4 fw-light lh-base text-body mb-0 opacity-50 fs-18 text-slate">
									Jarvis Connection®, çalışanların motivasyonunu artıran, kuruma olan bağlılığını güçlendiren sadakat yapıları sunar. Eğitim, görev, iç iletişim ve katılım bazlı olarak kurgulanan sistem, çalışanların performans ve katkılarına göre puan kazanmalarını ve bu puanlarla ödüllendirilmelerini sağlar. Kurum kültürüne entegre edilen bu yapı, sadece sadakati değil iç verimliliği de artırır.
								</p>
							</Col>
						</Row>
						<Row className="gy-8 row-cols-lg-3 row-cols-2">
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaTasks size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Görevler</h3>
									<p className="mb-0 fw-light small text-slate">Çalışanlara bireysel veya ekip bazlı görevler atanabilir. Katılım ve başarı, puan ve ödülle desteklenir.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaGraduationCap size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Eğitim / Sertifikasyon</h3>
									<p className="mb-0 fw-light small text-slate">Kurum içi eğitimler oyunlaştırılarak hem bilgi düzeyi hem de bağlılık artırılır.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaTrophy size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">İç Yarışmalar & Katılım</h3>
									<p className="mb-0 fw-light small text-slate">İç iletişim, oyunlaştırılmış aktiviteler ve performans tablolarıyla sürekli canlı tutulur.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaAward size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Çalışanlara Özel Ödüller</h3>
									<p className="mb-0 fw-light small text-slate">Kurum kültürünü destekleyen, kişiselleştirilmiş ödüllerle motivasyon yükseltilir.</p>
								</div>
							</Col>
						</Row>
					</Container>
				</section>

				<section className="bg-gray-lightest py-sm-10 py-5" id="sadakat-modulleri">
					<Container>
						<Row className="text-center mb-sm-9 mb-5 justify-content-center">
							<Col lg={10} className="col-10">
								<h2 className="mb-4">Sadakat Modülleri</h2>
								<p className="h4 fw-light lh-base text-body mb-0 opacity-50 fs-18 text-slate">
									Jarvis Connection®, müşterinin her hareketini sadakate dönüştürebilen yeni nesil bir motordur. Veri nereden gelirse gelsin, sistem bu veriyi işler, anlamlandırır, kişiye özel hedeflere yönlendirir, davranışı değiştirir ve bu değişimi analiz ederek döngüsel bir sadakat ekosistemi kurar.
								</p>
							</Col>
						</Row>
						<Row className="gy-8 row-cols-lg-3 row-cols-2">
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaUsers size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Segmentasyon ve Kişiselleştirme</h3>
									<p className="mb-0 fw-light small text-slate">Hem statik hem dinamik segmentasyon özellikleriyle kullanıcıları davranışlarına, etkileşim geçmişlerine ve demografik özelliklerine göre sınıflandırır.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaUserCircle size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Parametrik Portal Yönetimi</h3>
									<p className="mb-0 fw-light small text-slate">Kod yazmadan, sürükle-bırak mantığıyla tüm sadakat yapısı kontrol edilebilir. Kurallar, ödüller, kampanyalar ve segmentler sistemde parametrik olarak tanımlanabilir.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaAward size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Kademe Yönetimi</h3>
									<p className="mb-0 fw-light small text-slate">Statik ya da dinamik yapıdaki üyelik seviyeleri, davranışa göre özelleştirilebilir. Dilerseniz zaman bazlı, harcama bazlı ya da özel kulüp üyeliği gibi katmanlar oluşturabilirsiniz.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaWallet size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Ödüller</h3>
									<p className="mb-0 fw-light small text-slate">Her segmente, her kullanıcıya göre uyarlanabilir, sınırsız ödül kataloğu sunulabilir. İş ortağı hediye çekleri, özel kampanyalar, deneyimsel ödüller ya da sadece o kişiye özel sürprizler gibi esnek bir yapı mümkündür.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaReceipt size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Dijital Cüzdan ve Ödeme Altyapısı</h3>
									<p className="mb-0 fw-light small text-slate">Mobil cüzdan entegrasyonlarıyla müşteriler tüm kazançlarını cebinde taşır. Kurumlar, puan-TL dengesini tanımlar, ödül puanlarını belirler.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaCoins size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Makbuz Taraması</h3>
									<p className="mb-0 fw-light small text-slate">Offline alışverişin görünmezliğini ortadan kaldırıyoruz. Müşteri fişini yükler, sistem bunu işler, doğrular ve puana çevirir.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaUserFriends size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Ekonomi Puanları</h3>
									<p className="mb-0 fw-light small text-slate">Puan, sadece bir sayı değil bir değer ölçüsüdür. Markalar kendi TL-puan kurgularını tanımlar, esnek şekilde ödül bütçesini ve dönüş oranlarını yönetebilir.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaShoppingCart size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Kulüpler</h3>
									<p className="mb-0 fw-light small text-slate">Kullanıcılar gruplar halinde hareket edebilir, birlikte kazanır, birlikte harcar. Takım ruhu ile sadakat duygusu birleştirilir.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaTasks size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Görevler</h3>
									<p className="mb-0 fw-light small text-slate">Kullanıcılara hedefe yönelik bireysel veya grup görevleri sunulur. Davranışa dayalı görev akışları sayesinde sadakat süreci aktif katılımla zenginleşir.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaGamepad size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Oyunlaştırma ve Yönlendirmeler</h3>
									<p className="mb-0 fw-light small text-slate">Sadakat, eğlenerek öğrenmeye dönüşür. Görevler, skor tabloları, avatarlar, yarışmalar, öneri sistemleri ile kullanıcılar sistemde aktif kalır.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaBook size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Satış Bazlı</h3>
									<p className="mb-0 fw-light small text-slate">Bayilerden nihai tüketiciye kadar tüm satış verilerini sadakat deneyimine dönüştürüyoruz. KPI bazlı hedef kurguları, satışın ötesine geçerek davranış değişimini tetikliyor.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaShoppingCart size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Kampanya Katılımı</h3>
									<p className="mb-0 fw-light small text-slate">Katılımı sadece izlemek değil, kurgulamak üzerine kuruludur. Segment bazlı kampanya tasarımlarıyla hedefe yönelik, ilgi çekici ve dönüş alacak yapılar sunar.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaGraduationCap size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Eğitim / Sertifikasyon</h3>
									<p className="mb-0 fw-light small text-slate">Sadakati bilgi ile buluşturuyoruz. Akademi modülü ile hem öğretici hem oyunlaştırılmış eğitim kurguları sunuyoruz.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaUserTie size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Müşteri Yönetimi</h3>
									<p className="mb-0 fw-light small text-slate">Her kaynaktan veri alıp, tüm bu verileri birleştirerek tekil ve anlamlı bir müşteri profili oluşturuyoruz.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaUserFriends size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Çalışanlara Özel Uygulamalar</h3>
									<p className="mb-0 fw-light small text-slate">İç motivasyonu dış sadakatle eşleştiriyoruz. Çalışanların hedeflerine, başarılarına ve katılımlarına göre oyunlaştırılmış ödül ve puan yapıları kuruyoruz.</p>
								</div>
							</Col>
						</Row>
					</Container>
				</section>

				<section className="py-sm-10 py-5" id="teknoloji-altyapisi">
					<Container>
						<Row className="text-center mb-sm-9 mb-5 justify-content-center">
							<Col lg={10} className="col-10">
								<h2 className="mb-4">Teknoloji Altyapısı</h2>
								<p className="h4 fw-light lh-base text-body mb-0 opacity-50 fs-18 text-slate">
									Jarvis Connection®, bulut tabanlı bir SaaS (Software as a Service) platformudur. Her ölçekten işletmeye, herhangi bir teknik geliştirme süreci gerektirmeden, esnek ve hızlı uygulanabilir sadakat çözümleri sunar. Yazılım güncellemeleri, bakım ve altyapı operasyonları bizim sorumluluğumuzdadır; siz sadece kullanıcı deneyimine odaklanırsınız.
								</p>
							</Col>
						</Row>
						<Row className="gy-8 row-cols-lg-3 row-cols-2">
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaShieldAlt size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Fraud Önleme ve Denetim Mekanizmaları</h3>
									<p className="mb-0 fw-light small text-slate">Sahtecilik girişimlerine karşı gelişmiş kurallar, limitler ve anomali tespiti algoritmalarıyla donatılmıştır. Sistem, dolandırıcılık riskini en aza indirmek için kullanıcı davranışlarını sürekli analiz eder.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaDatabase size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Veri Yönetimi ve Uyumluluk</h3>
									<p className="mb-0 fw-light small text-slate">Müşteri Verisi Platformu (CDP), farklı kaynaklardan gelen verileri birleştirerek her kullanıcı için tekil ve zenginleştirilmiş bir profil oluşturulmasını sağlar.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaTachometerAlt size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Performans</h3>
									<p className="mb-0 fw-light small text-slate">Sürekli yüklenmeye uygun yapısı, tüm modülleriyle hızlı ve kararlı çalışır. Gerçek zamanlı analiz, kesintisiz hizmet ve yüksek veri hacmine uygun mimari.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaFileAlt size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">API Belgeleri</h3>
									<p className="mb-0 fw-light small text-slate">Tüm sistemlerle kolay entegrasyon için geliştirici dostu, açık API dokümanları sunuyoruz. Test ve geliştirme süreçleri için sandbox altyapımız mevcuttur.</p>
								</div>
							</Col>
							<Col>
								<div className="pe-md-5 pe-0">
									<div className="bg-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-3 mb-4 w-[80px] h-[80px]">
										<FaLock size={32} className="text-secondary" />
									</div>
									<h3 className="mb-3 h5">Güvenlik</h3>
									<p className="mb-0 fw-light small text-slate">Rol bazlı erişim, çift aşamalı doğrulama ve güvenli bulut altyapımız sayesinde tüm verileriniz ölçeklenebilir, yüksek erişilebilirlikte ve güvenli bir ortamda saklanır.</p>
								</div>
							</Col>
						</Row>
					</Container>
				</section>

				<section className="mb-sm-10 mb-5">
					<Container>
						<div className="bg-secondary shadow-lg-secondary py-sm-8 py-5 rounded-3">
							<Row className="justify-content-center">
								<Col xxl={6} lg={8} className="col-10 text-center">
									<h1 className="text-white mb-4">Jarvis'le tanışmaya hazır mısınız?</h1>
									<p className="text-white fw-light mb-0">Veriye dayalı kararlar, müşteri sadakati ve gelir artışı için jarvisology'yi keşfedin! harekete geçin, başarıyı yakalayın!</p>
									<div className="text-center mt-5">
										<Button as={Link} to="/login" variant="white" className="rounded-pill text-secondary px-4 py-3 d-inline-flex align-items-center gap-3">
											Hemen deneyin
											<svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
												<path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
											</svg>
										</Button>
									</div>
								</Col>
							</Row>
						</div>
					</Container>
				</section>

				<section className="pb-sm-10 pb-5">
					<Container>
						<Row className="text-center mb-sm-9 mb-5 justify-content-center">
							<Col lg={6} className="col-10">
								<h2>Sıkça Sorulan Sorular</h2>
							</Col>
						</Row>
						<Row className="gy-8 row-cols-lg-2">
							<Col md={6}>
								<div className="pe-md-5 pe-0">
									<h5 className="mb-3">Jarvis Connection® sadakat programı nedir ve nasıl işler?</h5>
									<p className="mb-0 fw-light small opacity-50">Jarvis Connection®, müşteri, çalışan ve kanal bağlılığını artırmak için özelleştirilmiş paket çözümler sunar. Veri analizi ve öğrenme modelleri ile bireylerin ve grupların davranışlarını analiz eder, bu bilgileri kullanarak kişiselleştirilmiş sadakat ve bağlılık programları oluşturur.</p>
								</div>
							</Col>
							<Col md={6}>
								<div className="pe-md-5 pe-0">
									<h5 className="mb-3">Jarvis Connection® ile müşteri deneyimini nasıl özelleştirebilirim?</h5>
									<p className="mb-0 fw-light small opacity-50">Jarvis Connection® sadakat programı, müşteri verilerini analiz ederek, her müşteriye özgü deneyimler sunmanıza olanak tanır. Müşteri beklentileri ve ihtiyaçlarına göre dinamik ve esnek sadakat programları oluşturarak, müşteri bağlılığını ve marka sadakatini artırır.</p>
								</div>
							</Col>
							<Col md={6}>
								<div className="pe-md-5 pe-0">
									<h5 className="mb-3">Jarvis Connection® çalışan bağlılığını nasıl artırır?</h5>
									<p className="mb-0 fw-light small opacity-50">Jarvis Connection® yeni nesil çalışan sadakat programı ile çalışanların motivasyonlarını ve bağlılıklarını artırır. Çalışanların ihtiyaçlarını ve isteklerini anlayarak, iş yerinde daha verimli ve tatmin edici bir ortam yaratır. Oyunlaştırma ve kişiselleştirilmiş ödüllendirme sistemleri ile çalışanların bağlılığını güçlendirir.</p>
								</div>
							</Col>
							<Col md={6}>
								<div className="pe-md-5 pe-0">
									<h5 className="mb-3">Jarvis Connection®'ın kanal bağlılık programları nedir ve nasıl işler?</h5>
									<p className="mb-0 fw-light small opacity-50">Jarvis Connection® kanallar üzerinden sadakat programı, satış ve servis kanallarınızla güçlü, tutkulu ve sürdürülebilir bir bağlantı kurmayı hedefler. Özelleştirilmiş CRM, satış ve pazarlama stratejileri ile kanal bağlılığını artırır, müşteri ve çalışan sadakatini geliştirir.</p>
								</div>
							</Col>
						</Row>
					</Container>
				</section>
			</main>
			<Footer />
		</>
	);
};

export default LandingPage;
